export default __webpack_public_path__ + "static/media/1.65349bb8.png";